import { render, staticRenderFns } from "./ContractRecognition.vue?vue&type=template&id=3904b48a&scoped=true"
import script from "./ContractRecognition.vue?vue&type=script&lang=js"
export * from "./ContractRecognition.vue?vue&type=script&lang=js"
import style0 from "./ContractRecognition.vue?vue&type=style&index=0&id=3904b48a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3904b48a",
  null
  
)

export default component.exports